exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css);", ""]);

// module
exports.push([module.id, ".countdown-container,\n.winner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.countdown-text,\n.winner-text {\n  font-size: 72px;\n  font-weight: bold;\n  color: #333;\n}\n\n.start-button {\n  padding: 12px 24px;\n  font-size: 24px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.winner-container {\n  animation: bounceInDown 1s; /* Add the desired animation effect */\n}\n", ""]);

// exports
